import { routeTranslations } from './routes'
import { DEFAULT_LOCALE, isLocale, type Locale } from './locales'
import { normalizeLocale } from '@/utils/locale'
import { i18n } from '@/plugins/i18n'

type RouteKey = keyof typeof routeTranslations
export type RouteParams = Record<string, string | number>

function compilePath(template: string, params: RouteParams = {}) {
  return template.replace(/:([A-Za-z0-9_]+)/g, (_, key) => {
    const val = params[key]
    if (val === undefined) {
      throw new Error(`[i18nPath] Missing param "${key}" for template "${template}"`)
    }
    return encodeURIComponent(String(val))
  })
}

export function localizedPath(
  key: RouteKey,
  params?: RouteParams,
  localeOverride?: Locale,
): string {
  const activeLocale = normalizeLocale(String(i18n.global.locale.value || DEFAULT_LOCALE))
  const resolvedLocale = localeOverride ?? activeLocale

  const locale = isLocale(resolvedLocale) ? resolvedLocale : DEFAULT_LOCALE

  const template = routeTranslations[key]?.[locale]

  if (template === undefined) {
    console.warn(`[i18nPath] Missing route for "${String(key)}" in locale "${locale}"`)
    return locale === DEFAULT_LOCALE ? '/' : `/${locale}`
  }

  const compiled = compilePath(template, params)

  if (locale === DEFAULT_LOCALE) {
    return compiled ? `/${compiled}` : '/'
  }

  return compiled ? `/${locale}/${compiled}` : `/${locale}`
}
